import React, { useMemo } from 'react'
import { Button, Card, Empty, Space, Spin, Tag, Typography } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useGwGoodsListQuery } from '../../store/ReactWebSiteApi'

const { Text, Title } = Typography

function H5sysGoodsList() {
    const navigate = useNavigate()

    const query = useMemo(
        () => ({
            eowg_e_id: localStorage.getItem('e_id'),
            eowg_sub_type_id: '',
            eowg_type_id: '',
            eowg_state: '',
        }),
        []
    )

    const { data, isFetching, isLoading } = useGwGoodsListQuery(query, { refetchOnMountOrArgChange: 1 })

    const list = useMemo(() => {
        if (data?.Status !== 'success' || !Array.isArray(data?.Result)) return []
        return data.Result
            .map((item) => ({
                key: item.eowg_id,
                eowg_name: item.eowg_name,
                eowg_serial_number: item.eowg_serial_number,
                eowgt_id: item.eowgt_id,
                eowgt_name: item.eowgt_name,
                eowgts_id: item.eowgts_id,
                eowgts_name: item.eowgts_name,
                eowg_content: item.eowg_content,
                eowg_shuoming: item.eowg_shuoming,
                eowg_state: item.eowg_state,
                eowg_ctime: item.eowg_ctime,
                eowg_update_ctime: item.eowg_update_ctime,
                guige: item.guige || [],
            }))
            .sort((a, b) => +a.eowg_serial_number - +b.eowg_serial_number)
    }, [data])

    return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>
            <div
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    background: '#fff',
                    padding: '12px 14px',
                    borderBottom: '1px solid #f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                }}
            >
                <HomeOutlined
                    style={{ fontSize: 20, color: '#1677ff' }}
                    onClick={() => navigate('/H5sysHome')}
                />
                <Title level={5} style={{ margin: 0 }}>
                    商品管理
                </Title>
            </div>

            <div style={{ padding: 12 }}>
                {(isLoading || isFetching) && (
                    <div style={{ textAlign: 'center', padding: '30px 0' }}>
                        <Spin />
                    </div>
                )}

                {!isLoading && !isFetching && list.length === 0 && <Empty description="暂无商品" />}

                <Space direction="vertical" size={10} style={{ width: '100%' }}>
                    {list.map((item) => (
                        <Card key={item.key} variant="borderless" style={{ borderRadius: 10 }}>
                            <Space direction="vertical" size={6} style={{ width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Text strong>{item.eowg_name}</Text>
                                    {item.eowg_state === '2' ? (
                                        <Tag color="green">待上架</Tag>
                                    ) : (
                                        <Tag color="#e20001">已上架</Tag>
                                    )}
                                </div>
                                <Text type="secondary">
                                    序号/编号：{item.eowg_serial_number} / {item.key}
                                </Text>
                                <Text type="secondary">
                                    类型：{item.eowgt_name}-{item.eowgts_name}
                                </Text>
                                {!!item.eowg_shouming && <Text>说明：{item.eowg_shouming}</Text>}
                                <Button
                                    type="primary"
                                    block
                                    onClick={() =>
                                        navigate('/H5sysGoodsNewUser', {
                                            state: {
                                                eowg_id: item.key,
                                                eowg_name: item.eowg_name,
                                                eowgg_id: item.guige?.[0]?.eowgg_id || '',
                                                eowgg_name: item.guige?.[0]?.eowgg_name || '',
                                                eowg_shuoming: item.eowg_shuoming,
                                                eowgt_id: item.eowgt_id,
                                                eowgt_name: item.eowgt_name,
                                                eowgts_id: item.eowgts_id,
                                                eowgts_name: item.eowgts_name,
                                            },
                                        })
                                    }
                                >
                                    新用户
                                </Button>
                            </Space>
                        </Card>
                    ))}
                </Space>
            </div>
        </div>
    )
}

export default H5sysGoodsList